module.exports = __webpack_public_path__ + "static/img/8.11a592e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/8.png
// module id = VjyZ
// module chunks = 0